import React from "react";

const InstagramIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.172.053 1.977.232 2.69.521a4.616 4.616 0 0 1 2.07 2.07c.288.712.468 1.518.52 2.69.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.052 1.172-.232 1.977-.52 2.69a4.616 4.616 0 0 1-2.07 2.07c-.712.288-1.518.468-2.69.52-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.172-.053-1.977-.232-2.69-.521a4.616 4.616 0 0 1-2.07-2.07c-.288-.712-.468-1.518-.52-2.69-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.053-1.172.232-1.977.521-2.69a4.616 4.616 0 0 1 2.07-2.07c.712-.288 1.518-.468 2.69-.52C8.416 2.175 8.796 2.163 12 2.163m0-1.604c-3.26 0-3.652.014-4.929.072-1.28.058-2.166.246-2.937.542a6.22 6.22 0 0 0-2.75 2.75c-.296.77-.484 1.658-.542 2.938-.058 1.277-.072 1.668-.072 4.928s.014 3.65.072 4.928c.058 1.28.246 2.167.542 2.937a6.22 6.22 0 0 0 2.75 2.75c.77.296 1.657.484 2.937.542 1.277.058 1.668.072 4.929.072s3.652-.014 4.928-.072c1.28-.058 2.167-.246 2.937-.542a6.22 6.22 0 0 0 2.75-2.75c.296-.77.484-1.657.542-2.937.058-1.277.072-1.668.072-4.928s-.014-3.65-.072-4.928c-.058-1.28-.246-2.167-.542-2.937a6.22 6.22 0 0 0-2.75-2.75c-.77-.296-1.657-.484-2.937-.542C15.652.573 15.26.559 12 .559z" />
    <path d="M12 6.117a5.883 5.883 0 1 0 0 11.766 5.883 5.883 0 0 0 0-11.766zm0 9.82a3.937 3.937 0 1 1 0-7.874 3.937 3.937 0 0 1 0 7.874z" />
    <circle cx="18.404" cy="5.596" r="1.44" />
  </svg>
);

export const Contacts = () => {
  return (
    <footer
      id="contacts"
      className="bg-[#01333E] text-gray-200 font-montserrat mt-16"
    >
      <div className="container mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 lg:gap-16">
          <div className="md:col-span-4 lg:col-span-3 text-center md:text-left mb-6 md:mb-0">
            <h5 className="text-xl font-semibold text-white mb-2">
              ТОО "EduMAX"
            </h5>
            <p className="text-sm text-gray-400">
              Современные методики и инновации в образовании
            </p>
          </div>

          <div className="md:col-span-4 lg:col-span-3">
            <h6 className="mb-4 font-semibold uppercase tracking-wider text-sm text-gray-100">
              Навигация
            </h6>
            <ul className="space-y-3">
              <li>
                <a
                  href="/"
                  className="hover:text-white hover:underline transition-colors duration-200 text-sm"
                >
                  Главная
                </a>
              </li>
              <li>
                <a
                  href="/#about"
                  className="hover:text-white hover:underline transition-colors duration-200 text-sm"
                >
                  О нас
                </a>
              </li>
              <li>
                <a
                  href="/#coursesList"
                  className="hover:text-white hover:underline transition-colors duration-200 text-sm"
                >
                  Курсы
                </a>
              </li>
              <li>
                <a
                  href="/#council"
                  className="hover:text-white hover:underline transition-colors duration-200 text-sm"
                >
                  Состав
                </a>
              </li>
              <li>
                <a
                  href="/#partners"
                  className="hover:text-white hover:underline transition-colors duration-200 text-sm"
                >
                  Сотрудничество
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4 lg:col-span-6">
            <h6 className="mb-4 font-semibold uppercase tracking-wider text-sm text-gray-100">
              Контакты
            </h6>
            <div className="space-y-4 text-sm">
              <a
                href="mailto:info.edumax.kz@gmail.com"
                className="flex items-start hover:text-white transition-colors duration-200 group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="mr-3 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-white transition-colors duration-200 mt-0.5"
                >
                  <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                  <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                </svg>
                <span>info.edumax.kz@gmail.com</span>
              </a>
              <div className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="mr-3 h-5 w-5 flex-shrink-0 text-gray-400 mt-0.5"
                >
                  <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                  <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                </svg>
                <div>
                  <p className="font-medium text-gray-100 mb-1">Казахстан</p>
                  <p>г.Астана, ул. Кошкарбаева 1/4, БЦ Downtown, этаж 3</p>
                </div>
              </div>
              <div className="flex items-start group">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="mr-3 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-white transition-colors duration-200 mt-0.5"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                    clipRule="evenodd"
                  />
                </svg>
                <div className="flex flex-col sm:flex-row sm:space-x-4">
                  <a
                    href="tel:77776097238"
                    className="hover:text-white hover:underline transition-colors duration-200"
                  >
                    +7 777 609 7238
                  </a>
                </div>
              </div>
              <a
                href="https://www.instagram.com/edumax.kz/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start hover:text-white transition-colors duration-200 group"
              >
                <InstagramIcon
                  className="mr-3 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-white transition-colors duration-200 mt-0.5"
                  aria-hidden="true"
                />
                <span>@edumax.kz</span>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-700/50 pt-8 text-center space-y-2">
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} Все права защищены:{" "}
            <span className="font-medium text-gray-200">ТОО "EduMAX"</span>
          </p>
          <p className="text-xs">
            <a href="https://wa.me/77715220681?text=Здравствуйте, хочу заказать разработку сайта.">
              Developed by Alikhan Talipbayev
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Contacts;
